import { Grid } from "antd-mobile";
import { useTranslation } from "react-i18next";
import gameListsEnum from "../../enumeration/gameListsEnum";
import styles from "./style.module.scss";
import "./styles.scss";
function GameWrap({ game, onGameItemClick, moreOnClick = () => { }, nowActiveType = 1 }) {
  const { t } = useTranslation();

  const getGameList = () => {
    if (!gameListsEnum[game.code]) return [];
    if (nowActiveType === 1) {
      return gameListsEnum[game.code]?.game_list.slice(0, 3);
    }
    return gameListsEnum[game.code]?.game_list;
  };

  const renderImage = () => {
    const gameList = getGameList();
    return (
      <Grid columns={gameListsEnum[game.code]?.column ?? 3} gap={8}>
        {gameList.map((item) => {
          return (
            <Grid.Item
              className={styles.gameImageContainer}
              key={item.code}
              onClick={() => {
                onGameItemClick(game, item);
              }}
            >
              {game.maintenance_status === 0 ? (
                <img className={styles.gameImage} src={item.image} alt={item.name} />
              ) : (
                <div className={styles.maintainContainer}>
                  <img className={styles.gameImage} src={item.image} alt={item.name} />
                  <img
                    className={styles.maintiainImage}
                    src="images/icons/maintain.png"
                    alt="maintain"
                  />
                </div>
              )}
            </Grid.Item>
          );
        })}
      </Grid>
    );
  };

  return (
    <>
      {game.code === "saba" && game.maintenance_status === 1 ? (
        ""
      ) : (
        <>
          <div className={styles.gameTitleArea}>
            <div className={styles.gameTitle}>{t(`games.fullName.${game.code}`)}</div>
            <div onClick={moreOnClick} className={styles.gameMore}>
              <span>{t("normal.more")}</span>
              <img style={{ marginLeft: "9.5px" }} src="/images/icons/moreArrow.png" alt="more" />
            </div>
          </div>
          <div className={styles.gameOutsideContainer}>{renderImage()}</div>
        </>
      )}
    </>
  );
}

export default GameWrap;
